import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '../../../apis/baseQuery';
import { API_CONSTANTS } from '../../../utils/constants';
import { ApiResponse } from '../../../model';

import type { PushNotificationDetail } from './model';

export const pushNotificationsApi = createApi({
  reducerPath: 'pushNotificationsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PushNotification'],
  endpoints: (build) => ({
    getPushNotificationDetail: build.query<
      ApiResponse<PushNotificationDetail>,
      string
    >({
      query: (templateId) => ({
        url: API_CONSTANTS.PUSH_NOTIFICATIONS.DETAIL_URL(templateId),
        method: 'GET',
      }),
      providesTags: (_result, _error, templateId) => [
        { type: 'PushNotification', id: templateId },
      ],
    }),
    editPushNotification: build.mutation<
      ApiResponse<Record<string, never>>,
      { id: string; title?: string; message?: string; status?: string }
    >({
      query: (body) => ({
        url: API_CONSTANTS.PUSH_NOTIFICATIONS.EDIT_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'PushNotification', id },
        { type: 'PushNotification', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useLazyGetPushNotificationDetailQuery,
  useEditPushNotificationMutation,
} = pushNotificationsApi;

export default pushNotificationsApi;
